import type { HTMLAttributes } from 'react';

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export function Skeleton({ className, ...rest }: SkeletonProps): JSX.Element {
  const cls = [
    'animate-pulse rounded-md bg-bg-muted',
    className ?? 'h-4 w-full',
  ]
    .filter(Boolean)
    .join(' ');
  return <div className={cls} aria-hidden="true" {...rest} />;
}
